export default "/assets/images/bigsneeze-filter.14c103db70a81c76.png";